<template>
  <div>
    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        shop
      </h1>
    </div>
    <p class="mb-12 text-tiny">
      The following items are available for immediate purchase through the National Horseman's online store. Orders will be processed real-time
      to the credit/debit card that you enter during your transaction. Please note that prices do not include shipping and handling and that it will be
      added in and shown to you before you submit your final order. In addition, residents of the state of Arizona will be charged sales tax on their orders.
    </p>

    <div class="shop_products" v-if="ready">
      <template v-for="offer in offers">
        <div class="flex flex-col lg:flex-row relative lg:justify-center">
          <div class="basis-1/1 mb-3 lg:basis-1/6 lg:mb-0">
            <nuxt-img
                width="150"
                height="194"
                format="webp"
                class="px-4 mb-3"
                :src=" siteURL +  '/storage/images/offers/' + offer.album_path + '/cache/' + offer.image_cached "
                :alt="offer.title"
            />
          </div>
          <div class="basis-1/1 mb-1.5 lg:basis-1/2 mb-0 px-4">
              <p class="font-bold leading-5 mb-2.5">{{offer.title}}</p>
              <p class="font-bold leading-5 mb-2.5">{{offer.illustrations}}</p>
              <div v-html="offer.description"></div>
              <div class="flex justify-end mb-2.5">
                <div>
                  ${{offer.price}}
                </div>
                <Transition name="slide">
                  <div v-if="offer.show" class="absolute bottom-0 right-0 w-[25%] bg-darkRed">
                    <p></p>
                  </div>
                </Transition>
                <button class="bg-themeRed text-white rounded-lg uppercase text-xs p-1.5 ml-1.5" @click="addToCart(offer.id)">buy now</button>
              </div>
          </div>
        </div>
      </template>
    </div>
    <div v-else>
      <LoadersSpinner />
    </div>
  </div>
</template>
<script setup>
import {http} from "~/utils/http";
import {ref} from "vue";
import { useMainStore } from "@/stores/main";
import {useSiteURL} from "~/composables/state";

const offers = ref([]);
const ready = ref(false);
const mainStore = useMainStore();
const siteURL = useSiteURL();

const addToCart = (id) => {
  let i = offers.value.map((item) => item.id).indexOf(id);

  let payload = {
    cartId: offers.value[i].id,
    product_id: offers.value[i].id,
    name: offers.value[i].title,
    price: offers.value[i].price,
    quantity: 1,
    category: offers.value[i].type_id,
    category_option: offers.value[i].item_type,
    option_name: '',
    product_type: offers.value[i].product_type,
    shipping_tax_ca: offers.value[i].shipping_tax_ca,
    shipping_tax_us: offers.value[i].shipping_tax_us,
    shipping_tax_za: offers.value[i].shipping_tax_za,
  }

  offers.value[i].show = !offers.value[i].show;
  setTimeout(()=>{
    offers.value[i].show = !offers.value[i].show;
  },100)

  mainStore.addProduct(payload);
}

const getData = async () => {
  try {
    await http
        .get("/api/offers")
        .then((response) => {
          response.data.offers.forEach((offer)=> {
            if (offer.type_id === 2 && offer.item_type === 2 && offer.active === 1 && offer.visible_on_site === 1) {
              offers.value.push({
                id: offer.id,
                show: false,
                title: offer.title,
                price: offer.price,
                description: offer.content,
                illustrations: offer.illustrations,
                album_path: offer.album_path,
                image_cached: offer.image_cached,
                type_id: offer.type_id,
                item_type: offer.item_type,
                product_type: offer.product_type,
                shipping_tax_ca: offer.shipping_tax_ca,
                shipping_tax_us: offer.shipping_tax_us,
                shipping_tax_za: offer.shipping_tax_za,
              })
            }
          })
          ready.value = true;
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
};

getData();
</script>
<style>
.slide-enter-active {
  transition: all 0.3s ease-out;
}

.slide-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-leave-to {
  transform: translatey(-70vh);
  opacity: 0;
  width: 20px;
  height: 20px;
}
</style>
